module.exports = __webpack_public_path__ + "static/media/playbn.b4839ff7.png";